/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

document.addEventListener('DOMContentLoaded', function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  }

  let endTimeG

  function cutDownTime() {
    let nowTime = new Date()
    let endTime = new Date(endTimeG)

    let leftTime = endTime.getTime() - nowTime.getTime()
    if (leftTime < 0) {
      setupNewCountdown()
      leftTime = 0
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60)
    leftH = leftH >= 10 ? leftH : '0' + leftH
    leftM = leftM >= 10 ? leftM : '0' + leftM
    leftS = leftS >= 10 ? leftS : '0' + leftS

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    }
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9)
    const currentTime = new Date()
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
  }
  let intervalId

  function getCutDownTime() {
    setupNewCountdown()
    if (intervalId) clearInterval(intervalId)
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime()
      $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
      $('.sp_top_cut_down .sp_left_view .sp_minute').html(
        cutDownTimeText.minute
      )
      $('.sp_top_cut_down .sp_left_view .sp_second').html(
        cutDownTimeText.second
      )
    }, 1000)
  }

  getCutDownTime()

  let spImgList = [
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-p1.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-p2.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-p3.png',

    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-a1.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-a2.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-a3.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-b1.webp',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-b2.webp',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-b3.webp',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-b4.webp',

    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-b1-pc.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-b2-pc.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-b3-pc.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-b4-pc.png',

    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c1-pc.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c2-pc.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c3-pc.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c4-pc.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c5-pc.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c6-pc.png',

    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c1.webp',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c2.webp',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c3.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c4.png',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c5.webp',
    'https://cdn.shopify.com/s/files/1/0621/3366/5930/files/20251224-c6.png',
  ]

  new Swiper('.sp-swiper-fade-top', {
    spaceBetween: 10,
    effect: 'fade',
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 2000,
    },
    speed: 2000,
  })

  // // // 按钮轮播
  // new Swiper(".sp-btn-loop", {
  //   spaceBetween: 10,
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //     reverseDirection: true,
  //   },
  //   loop: true,
  // });

  // new Swiper(".sp-swiper1", {
  //   autoplay: true,
  //   autoplay: {
  //     disableOnInteraction: false,
  //   },
  //   spaceBetween: 20,
  //   loop: true,
  //   pagination: {
  //     el: ".sp-pagination1",
  //     clickable: true,
  //   },
  // });
  new Swiper('.sp-swiper0', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    spaceBetween: 20,
    loop: true,
  })
  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 20,
    loop: true,
  })
  new Swiper('.sp-swiper1-m', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 20,
    loop: true,
  })

  new Swiper('.sp-swiper2', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
      delay: 0,
    },
    speed: 6000,

    loop: true,
    centeredSlides: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
  })

  new Swiper('.sp-swiper2-m', {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },

    loop: true,
    centeredSlides: true,
    slidesPerView: 1.8,
    spaceBetween: 0,

    effect: 'coverflow',

    coverflowEffect: {
      rotate: 0,
      stretch: -60, // 每个slide之间的拉伸值，越大slide靠得越紧。
      depth: 130, //slide的位置深度。值越大z轴距离越远，看起来越小。
      modifier: 1,
      slideShadows: false,
    },
    pagination: {
      el: '.sp-pagination1',
      clickable: true,
    },
  })

  jQuery('.sp-scroll2').slide({
    mainCell: '.nav-imgs',
    autoPlay: true,
    effect: 'leftMarquee',
    interTime: 12,
    vis: 1,
    scroll: 1,
  })

  let _swiper = new Swiper('.sp-swiper-pro', {
    speed: 1,
    spaceBetween: 0,
  })

  let sp_price1 = window.product[0].price / 100,
    sp_price2 = window.product[0].compare_at_price / 100
  let sp_price3 = window.product[0].price / 100,
    sp_price4 = window.product[0].compare_at_price / 100
  // 有无绑品切换
$("input.toggle-input").on("change", function(e) {
    const index = $(this).attr("data-index");
    const type = $(this).attr("data-type");
    // console.log("index",index)
    // console.log("切换选项，索引:", index);
    
    // 获取当前所在的产品盒
    const $productBox = $(this).closest(".sp_product_box");
    
    // 切换图片显示
    $productBox.find(".sp-p-img").removeClass("sp-p-img-active").eq(index).addClass("sp-p-img-active");
    
    // 获取变体ID
    let id = $(this).attr("id");
    if(id.startsWith("PC-")){
        id = id.substring(3);
    } else if(id.startsWith("m-")){
        id = id.substring(2);
    }
    
    // console.log("找到变体ID:", id);
    
    // 从window.product中查找对应的变体
    const variant = window.product.find(v => v.id == id);
    if(variant) {
        // console.log("找到变体:", variant);
        
        // 获取当前数量
        const quantity = $productBox.find("#calcNumber").val() || 1;
        
        // 更新价格显示
        const price = variant.price / 100;
        const comparePrice = variant.compare_at_price / 100;

        // 数量控制的价格也要变
        if(type==1){
          sp_price1 = price
          sp_price2 = comparePrice
          sp_price3 = price
          sp_price4 = comparePrice
        }
        
        // 更新价格显示
        $productBox.find(".sp-price1, #sp_price1").each(function() {
            $(this).html('$' + (price * quantity).toFixed(2));
        });
        
        $productBox.find(".sp-price2, #sp_price2").each(function() {
            $(this).html('$' + (comparePrice * quantity).toFixed(2));
        });

        if(type==2){
          $productBox.find(".sp-price3 .sp-span").html('$' + (price/3).toFixed(2));
        }else if(type==3){
          $productBox.find(".sp-price3 .sp-span").html('$' + (price/5).toFixed(2));
        }
        
        // 更新购买按钮的data-id
        $productBox.find(".btn-style").attr("data-id", variant.id);
    }
});

  $(' .sp-option').click(function () {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')

    let colorOptions = $(' .sp-color .sp-option.active').index()
    let numOptions = $(' .sp-num .sp-option.active').index()
    let _index = colorOptions * 2 + numOptions
    // $("#sptext1").text(sptextList[colorOptions]);
    // let _index = colorOptions;
    _swiper.slideToLoop(_index)
  })

  // pc-产品点击放大
  $('.sp_product_box').click(function () {
    $(this).addClass('sp-active').siblings().removeClass('sp-active')
  })

  $('.sp-btn-skip').click(function () {
    $('.sp_pc .sp_product_box').removeClass('sp-active')
    $('.sp_pc .sp_product_box').eq(2).addClass('sp-active')
  })

  function mainRender() {
    $(function () {
      $('#root').css('zoom', 'normal')
      if (document.body.clientWidth <= 1080) {
        let scale = document.body.clientWidth / 1080
        $('#root').css('zoom', scale)
      } else {
        const scale = document.body.clientWidth / 1920
        $('#root').css('zoom', scale)
      }

      window.addEventListener(
        'resize',
        (function () {
          var timer
          return function () {
            if (timer) clearTimeout(timer)
            timer = setTimeout(function () {
              $('#root').css('zoom', 'normal')
              if (document.body.clientWidth <= 1080) {
                let scale = document.body.clientWidth / 1080
                $('#root').css('zoom', scale)
              } else {
                const scale = document.body.clientWidth / 1920
                $('#root').css('zoom', scale)
              }
            }, 100)
          }
        })()
      )
    })

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
      const config = {
        rootMargin: '0px 0px 1300px 0px',
        threshold: 0,
      }

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target
            const dataSrc = image.getAttribute('data-src')
            image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image) // 停止观察该图片
          }
        })
      },
      config)

      images.forEach(function (image) {
        lazyLoadObserver.observe(image) // 开始观察每个图片
      })
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach(subArray => {
          subArray.forEach(url => {
            const img = new Image()
            img.src = url
          })
        })
      } else {
        // 处理一维数组
        imageArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      }
    }

    lazyLoadImages()

    preloadImages(spImgList)

    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为

        // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop =
          document.body.clientWidth <= 1080
            ? targetElement.offsetTop - $('.sp-nav').height()
            : targetElement.offsetTop
        let sptop = document.body.clientWidth <= 1080 ? 60 : 80

        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            sptop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        })
      })
    })

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera
    var isAndroid = /android/i.test(userAgent)
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log('Android')
    } else if (isIOS) {
      console.log('iOS')
    } else if (isPC) {
      console.log('PC')
    } else {
      $('.sp_system').css('letter-spacing', '-4px')
    }
  }

  mainRender()

  function calcTotal(price, num) {
    let result = Number(price) * Number(num)

    return result.toFixed(2)
  }
  $('.sp_pc .sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    $('.sp_pc .sp_product_box1 .sp-price1').html(
      '$' + calcTotal(sp_price1, input.value)
    )
    $('.sp_pc .sp_product_box1 .sp-price2').html(
      '$' + calcTotal(sp_price2, input.value)
    )
  })
  $('.sp_pc .sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num

    $('.sp_pc .sp_product_box1 .sp-price1').html(
      '$' + calcTotal(sp_price1, input.value)
    )
    $('.sp_pc .sp_product_box1 .sp-price2').html(
      '$' + calcTotal(sp_price2, input.value)
    )
  })

  $('.sp_mobile .sp-reduce').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) - 1
    if (num > 0) {
      input.value = num
    }
    $('.sp_mobile .sp_product_box1 .sp-price1').html(
      '$' + calcTotal(sp_price3, input.value)
    )
    $('.sp_mobile .sp_product_box1 .sp-price2').html(
      '$' + calcTotal(sp_price4, input.value)
    )
  })
  $('.sp_mobile .sp-add').click(function () {
    let input = $(this).siblings('input')[0]
    let num = Number(input.value) + 1
    input.value = num

    $('.sp_mobile .sp_product_box1 .sp-price1').html(
      '$' + calcTotal(sp_price3, input.value)
    )
    $('.sp_mobile .sp_product_box1 .sp-price2').html(
      '$' + calcTotal(sp_price4, input.value)
    )
  })
   $('.sp-btn-style').click(function () {
    let num = $(this).prev().find("#calcNumber").val() || 1
    let id = $(this).data("id")
    window.location.href = '/cart/' + id + ':' + num
  })
  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-sub-title')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }

  // // 点击按钮
  // $(".sp-video-btn").click(function () {
  //   $(".sp-mask").css("display", "flex");
  // });

  // 菜单
  $('.sp-menu-btn').click(function (e) {
    $('.sp-menu-mask').show()
  })

  $('.sp-menu-mask').click(function (e) {
    // if ($(e.target).closest(".sp-menu-mask li").length > 0) {
    // } else {
    $('.sp-menu-mask').hide()
    // }
  })

  // 滚动隐藏顶部
  if (
    $(window).scrollTop() >
    $('.sp_header').height() * $('div#root').css('zoom')
  ) {
    $('.sp_header-wrap').addClass('sp-fixed')
  } else {
    $('.sp_header-wrap').removeClass('sp-fixed')
  }

  let spTimer = null
  let spHasShown = false // 防止重复显示

  $(window).scroll(function () {
    if (
      $(window).scrollTop() >
      $('.sp_header').height() * $('div#root').css('zoom')
    ) {
      $('.sp_header-wrap').addClass('sp-fixed')
    } else {
      $('.sp_header-wrap').removeClass('sp-fixed')
    }

    // 滚动添加底部
    if (spHasShown) return // 已经显示就不再触发

    // 如果没有定时器，则开始计时
    if (!spTimer && $(window).scrollTop() > 800) {
      spTimer = setTimeout(function () {
        document.querySelector('.sp-btn-style2').style.display = 'flex'
        spHasShown = true // 标记为已显示
      }, 3000)
    }
  })

  $(document).on('click', '.sp_buy_now', function () {
    console.log('xxx111')
  })

  // 问答
  $('.sp-qa2-question').on('click', function () {
    var $currentItem = $(this).closest('.sp-qa2-item')
    var $answer = $currentItem.find('.sp-qa2-answer')

    // 如果当前项已经打开 -> 关闭它
    if ($currentItem.hasClass('active')) {
      $answer.slideUp(300)
      $currentItem.removeClass('active')
    }
    // 如果当前项是关闭的 -> 开启它 (并关闭其他项)
    else {
      // 关闭其他所有项
      $('.sp-qa2-item').removeClass('active')
      $('.sp-qa2-answer').slideUp(300)

      // 开启当前项
      $currentItem.addClass('active')
      $answer.slideDown(300)
    }
  })

  // 文本渐出动画
  const graduallyList2 = document.getElementsByClassName('sp-fade-box')
  for (let gradually2 of graduallyList2) {
    const paragraph2 = gradually2.querySelectorAll('.sp-ani')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph2.forEach((span, index) => {
              span.style.animation = `sp-fade-in 1s ease forwards`
              span.style.animationDelay = `${index * 0.5 + 0.5}s`
            })

            observerAni.unobserve(gradually2)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually2)
  }
  // 文本渐出动画
  const graduallyList3 = document.getElementsByClassName('sp-fade-box2')
  for (let gradually3 of graduallyList3) {
    const paragraph3 = gradually3.querySelectorAll('.sp-ani2')

    const observerAni = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            paragraph3.forEach((span, index) => {
              span.style.animation = `sp-fade-left 1s ease forwards`
              span.style.animationDelay = `${index * 0.3 + 1}s`
            })

            observerAni.unobserve(gradually3)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observerAni.observe(gradually3)
  }
})
